export const Minus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M21.939 13.5616C21.8111 14.2545 21.1993 14.637 20.4962 14.6836C19.2336 14.7672 16.695 14.875 12 14.875C7.30503 14.875 4.7664 14.7672 3.5038 14.6836C2.80069 14.637 2.18888 14.2545 2.06104 13.5616C1.9904 13.1787 1.9375 12.6687 1.9375 12C1.9375 11.3313 1.9904 10.8213 2.06104 10.4384C2.18888 9.74547 2.80069 9.36295 3.5038 9.31638C4.7664 9.23281 7.30503 9.125 12 9.125C16.695 9.125 19.2336 9.23281 20.4962 9.31638C21.1993 9.36295 21.8111 9.74547 21.939 10.4384C22.0096 10.8213 22.0625 11.3313 22.0625 12C22.0625 12.6687 22.0096 13.1787 21.939 13.5616Z"
      fill="currentColor"
    />
  </svg>
);
